<textarea id="smsProgramado" class="form-control" rows="8" (input)="onInputKey($event.target.value)"
    [maxLength]="maxLength" [value]="value" [disabled]="isDisabled"></textarea>
<span class="letter-count" [ngClass]="{ 'invalid': contadorPorLetra === maxLength }">
    {{ contadorPorLetra + '/' + maxLength }}
</span>